const ACTIONS = {
  CLEAR: "clear",
  DECIMAL: "decimal",
  OPERATOR: "operator",
  DIGIT: "digit",
  EQUALS: "equals",
};

export default ACTIONS;
